import { render, staticRenderFns } from "./income-detail.vue?vue&type=template&id=4d39b25d&scoped=true"
import script from "./income-detail.vue?vue&type=script&lang=ts"
export * from "./income-detail.vue?vue&type=script&lang=ts"
import style0 from "./income-detail.vue?vue&type=style&index=0&id=4d39b25d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d39b25d",
  null
  
)

export default component.exports